import * as Icon from "@ant-design/icons";
import { Button, Checkbox, Col, DatePicker, Divider, Form, Input, Row, Space } from "antd";
import { useEffect, useState } from "react";
import { FeriadoModel } from "../../../../models/feriado/feriadoModel";
import { atualizarFeriado, cadastrarFeriado } from "../../../../services/feriadoService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import dayjs from "dayjs";
import { setModalCadastrarFeriado } from "../../../../redux/slices/feriado/feriadoSlice";

dayjs.locale("pt-br");

const CadastroFeriado = () => {
  //estados globais
  const feriadoState = useAppSelector((state) => state.feriado);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const editar = Object.values(feriadoState.entity).length !== 0;

  const [form] = Form.useForm<FeriadoModel>();
  const [checked, setChecked] = useState<any>("0");
  const [denominacao, setDenominacao] = useState("");

  const dateFormatVariavel = "DD/MM/YYYY";
  const dateFormatFixo = "DD/MM";

  useEffect(() => {
    if (editar) {
      form.setFieldsValue({
        ...feriadoState.entity,
        data: dayjs(feriadoState.entity.data),
      });
      setChecked(feriadoState.entity.tipo.toString());
    }
  }, [feriadoState.entity]);

  const submit = (value: any) => {
    const valueTotal = { ...value, tipo: parseInt(checked) };
    if (editar) {
      const updateFeriado = { id: feriadoState.entity.id, ...valueTotal };
      dispatch(atualizarFeriado({ value: updateFeriado, busca: feriadoState.busca }));
    } else {
      dispatch(cadastrarFeriado({ value: valueTotal, busca: feriadoState.busca }));
    }
  };

  const denominacaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDenominacao(e.target.value);
  };

  const voltar = () => {
    dispatch(setModalCadastrarFeriado(false));
  };

  return (
    <Form form={form} onFinish={submit} layout="vertical">
      <Row gutter={12}>
        <Col flex="auto" span={4}>
          <Form.Item name="tipo" label="Tipo de feriado">
            <div>
              <Checkbox value="0" checked={checked === "0"} onChange={() => setChecked("0")}>
                Fixo
              </Checkbox>
              <Checkbox value="1" checked={checked === "1"} onChange={() => setChecked("1")}>
                Variável
              </Checkbox>
            </div>
          </Form.Item>
        </Col>
        <Col flex="auto" span={4}>
          <Form.Item
            label="Data"
            name="data"
            rules={[
              {
                required: true,
                message: "Digite a data",
              },
            ]}
          >
            <DatePicker format={checked === "1" ? dateFormatVariavel : dateFormatFixo} />
          </Form.Item>
        </Col>
        <Col flex="auto" span={16}>
          <Form.Item
            label="Denominação"
            name="denominacao"
            className="denominacaoFeriado"
            rules={[
              {
                required: true,
                message: "Digite o feriado",
              },
            ]}
          >
            <Input type="text" onChange={denominacaoChange} />
          </Form.Item>
        </Col>
      </Row>
      <Divider></Divider>
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<Icon.CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<Icon.CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastroFeriado;
